exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-styles-workshop .accordion-head{display:block!important}.question-accordion-head{background-color:#f9f9f9}.question-accordion-content{padding:0 20px 0 50px!important}.is-closed .accordion-head,.is-closed .btn.empty.red{display:flex!important}.btn.empty.red{border:1px solid #ff5252;color:#ff5252;display:none}.btn.empty.red:hover{background-color:#ff5252;color:#fff}.is-open .accordion-head{display:none!important}.module-has-error .accordion-number{color:red;height:45px;width:45px;border-color:red;border-width:5px}.question-has-error p{color:red}.is-open .Collapsible__contentInner div{right:0}.workshop-card-module-item{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/css/accordion.scss
// module id = 971
// module chunks = 0